import { createContext } from "react";

export const GameCtx = createContext();
